import React, { useRef, useEffect } from 'react';

interface Props {
  src: string
  autoPlay?: boolean
  loop?: boolean
  muted?: boolean
  controls?: boolean
  playbackSpeed?: number
}

const Video = ({ src, autoPlay = false, loop = false, muted = true, controls = true, playbackSpeed = 1 }: Props) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if(!autoPlay) return
    const video = videoRef.current;
    if(!video) return
    video.playbackRate = playbackSpeed

    const handleEnded = () => {
      video.currentTime = 0; // Reset the video to the beginning
      video.play(); // Restart the video playback
    };

    video.addEventListener('ended', handleEnded);

    return () => {
      video.removeEventListener('ended', handleEnded);
    };
  }, []);


  return (
    <video ref={videoRef} controls={controls} autoPlay={autoPlay} muted={muted} loop={loop} playsInline className='mt2'>
      <source src={src} type="video/mp4" />
    </video>
  )
};

export default Video;
